export default "__VITE_ASSET__DlEg_sdY__"